import script from "./tableBottomIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./tableBottomIcon.vue?vue&type=script&setup=true&lang=js"

import "./tableBottomIcon.vue?vue&type=style&index=0&id=20934a36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20934a36"]])

export default __exports__